import { useState, useEffect } from 'react'

import { getBranchDetail } from '@user/store/branches/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useSelector } from 'react-redux'
import { selectBranchById } from '@user/store/branches/slice'
import { StoreData } from '@user/store/reducers/typings'
import { toast } from '@sales-center/components'

export const useGetBranchDetail = (startingId: string = '') => {
  const dispatch = useAppDispatch()
  const [id, setId] = useState<string>(startingId)
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const branch = useSelector((state) =>
    selectBranchById(state as StoreData, id),
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')
        const result = await dispatch(getBranchDetail(id))

        if (mounted) {
          if (getBranchDetail.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error('Error loading branch details')
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
          toast.error('Error loading branch details')
        }
      } finally {
        if (mounted) {
          setStatus('idle')
        }
      }
    }
    if (id.length && (!branch || !branch.loaded)) execute()

    return () => {
      mounted = false
    }
  }, [branch, dispatch, id])

  return { status, branch, branchId: id, setBranchId: setId }
}
